<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="isPaidBill ? 'Paid Bill' : 'Bill'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (loaded) {
      <tidy-card>
        <tidy-row [alignLastItemRight]="isLoggedIntoClientApp">
          <tidy-text
            [title]="'Bill From'" />
          @if (isLoggedIntoClientApp) {
            <div style="margin-right: -5px">
              <tidy-text
                [body]="'Copy Link'"
                (action)="copyBillLink()"
                class="link" />
            </div>
          }
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="proName | titlecase"
            [translate]="false" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="proEmail"
            [translate]="false" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="proPhone | telephone" />
        </tidy-row>
        <div style="position: relative; margin-left: -11px; margin-right: -11px; padding: 10px;">
          <div style="position: absolute; top: 0; left: 0; right: 0; height: 7px; background: #275C7C;"></div>
          <div style="padding-top: 7px">
            <tidy-row [alignLastItemRight]="true">
              <div>
                <tidy-text
                  [body]="'To: '" />
                <tidy-text
                  [body]="((companyName || clientName) | titlecase)"
                  [translate]="false" />
              </div>
              <div style="align-self: end; margin-right: -5px">
                <tidy-text
                  [body]="('Sent ' | translate) + (invoice?.created_at | parseDateTime:'MMM d':'local')" />
              </div>
            </tidy-row>
          </div>
        </div>
        <tidy-row class="extra-top-padding" [alignLastItemRight]="true">
          <tidy-text
            [body]="'Service'" />
          <tidy-text
            [body]="'Owed'" />
        </tidy-row>
        <tidy-row>
          <tidy-divider />
        </tidy-row>
        @for (service of invoice?.items; track service; let last = $last) {
          <tidy-row [alignLastItemRight]="true">
            <div style="width:85%">
              <tidy-text
                [header]="service?.service_details?.name | titlecase" />
            </div>
            <div>
              @if (service?.amount) {
                <tidy-text
                  [body]="service?.amount | tcurrency" />
              }
              @if (!service?.amount) {
                <tidy-text
                  [body]="invoice?.amount | tcurrency" />
              }
            </div>
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="(service?.service_details?.date | parseDateTime:'MMM d') +
              (' at ' | translate) +
              service?.service_details?.address?.address +
              ', ' +
              (service?.service_details?.address?.unit ? (('Unit ' | translate) + service?.service_details?.address?.unit + ', ') : '') +
              service?.service_details?.address?.zip"
              [translate]="false" />
          </tidy-row>
          @if (!cameFromClientHub) {
            <tidy-row class="extra-top-padding vertical-align-center">
              <tidy-image
                [src]="'assets/img/clock-black.svg'"
                class="header-size" />
              <tidy-text
                [body]="'Job Duration'" />
              @if (!proReportedDuration && !fromStartDuration) {
                <tidy-text
                  [body]="': N/A'" />
              }
            </tidy-row>
          }
          @if (proReportedDuration) {
            <tidy-row>
              <tidy-text
                [body]="'Reported by Pro:'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="proReportedDuration" />
              </tidy-row>
            }
            @if (fromStartDuration) {
              <tidy-row>
                <tidy-text
                  [body]="'Using Realtime Updates:'" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="fromStartDuration" />
                </tidy-row>
              }
              <tidy-row [ngClass] = "last ? '' : 'extra-bottom-padding'">
                <tidy-divider />
              </tidy-row>
            }
            <tidy-row [alignLastItemRight]="true">
              <tidy-text
                [header]="'Total'" />
              <tidy-text
                [body]="'<b>' + ((invoice?.amount + totalFees) | tcurrency) + '</b>'" />
            </tidy-row>
            @if (job?.payment?.cleaning_detail?.payments) {
              @for (payment of job.payment.cleaning_detail.payments; track payment) {
                <tidy-row>
                  <tidy-text
                    [body]="payment?.from_type_name"/>
                  <tidy-text
                    [body]="' - ' + (payment.amount | tcurrency)"/>
                  @if (payment?.fee?.amount) {
                    <tidy-text
                      [body]="' + ' + (payment.fee.amount*-1 | tcurrency) + ' (' + payment.fee.percentage + '% ' + ('processing fee' | translate) + ')'"/>
                  }
                </tidy-row>
              }
            }
            <tidy-row [alignLastItemRight]="true">
              <tidy-text
                body="Remaining Balance" />
              <tidy-text
                [body]="invoice?.amount_due | tcurrency" />
            </tidy-row>
            <tidy-row [align]="'center'">
              <tidy-text
                [body]="'We thank you for your business!'" />
            </tidy-row>
            <tidy-row class="no-padding" [align]="'center'">
              <tidy-text
                [body]="proName"
                class="signature"
                [translate]="false" />
            </tidy-row>
            <tidy-divider
              style="margin-top:-15px" />
            @if (isLoggedIntoClientApp) {
              <ng-container class="no-padding">
                <tidy-row class="extra-top-padding">
                  <tidy-text
                    [header]="'Bill Notes'" />
                </tidy-row>
                <tidy-row style="padding-bottom: 0px">
                  <form [formGroup]="form" novalidate action="#">
                    <tidy-select
                      style="width:35%; font-size: 8px"
                      [form]="form.controls.messageType"
                      formControlName="messageType"
                      [items]="messageSelectItems"
                      [smallText]="true"
                      [selectedItem]="selectedMessageType"
                      (optionChange)="updateIsInternalComment($event)"
                      [icon]="'assets/svg/chatbubble.svg'" />
                  </form>
                </tidy-row>
                <tidy-row style="padding-top: 3px">
                  <form [formGroup]="form" novalidate action="#">
                    <tidy-textarea
                      [label]="isInternalComment ? 'Add Internal Note' : 'Add Note'"
                      formControlName="message"
                      [form]="form.controls.message"
                      [submitted]="submitted"
                      [errorMessage]="'Please enter a message to send.'"
                      [rightIconAction]="boundSendMessage"
                      [leftIconAction]="boundSendAttachment"
                      [icon]="'assets/svg/chatbubble.svg'" />
                  </form>
                </tidy-row>
                @if (invoiceNotes?.length == 0) {
                  <tidy-row [align]="'center'">
                    <tidy-text
                      [helper]="'No Bill Notes'" />
                  </tidy-row>
                }
                <tidy-row />
                @for (note of invoiceNotes; track note) {
                  <message
                    [message]="note"
                    [last]="last"
                    [isInvoiceNote]="true" />
                }
              </ng-container>
            }
          </tidy-card>
        }
      </tidy-wrapper>
    </ng-template>

    @if (!isRightSideContent) {
      <app-scroll-wrapper [templateContent]="content" />
    }

    @if (isRightSideContent) {
      <ion-content class="ion-content-right-column">
        <ng-container *ngTemplateOutlet="content" />
      </ion-content>
    }
